/**
 * Regulatory / jurisdiction policy for crash games.
 * Feature code should read flags — never `if (jurisdiction === 'UK')`.
 */

export type WinCelebrationMode = 'all' | 'aboveStakeOnly' | 'none';

export type RulesSectionKey =
  | 'bet_cash_out'
  | 'auto_play'
  | 'auto_cash_out'
  | 'live_bets'
  | 'randomization'
  | 'game_menu'
  | 'other';

export interface RegulatoryPolicy {
  /** Jurisdiction id used for logs / debugging (`standard`, `UK`, …). */
  jurisdiction: string;
  /** Auto Play button, modal, stop conditions, and automatic next-round bets. */
  autoplay: boolean;
  /** Second bet panel. */
  dualBet: boolean;
  /** In-game chat. */
  chat: boolean;
  /** Spacebar / keyboard betting shortcuts. */
  keyboardBetting: boolean;
  /** Auto Cash Out toggle (independent of Auto Play). */
  autoCashout: boolean;

  centerAutoCashout: boolean;
  /** Cashout toast / win SFX. */
  winCelebration: WinCelebrationMode;
  /** Ordered Game Rules section keys. */
  rulesSections: RulesSectionKey[];

  rulesThirdPartyUiDisclaimer: boolean;
  /** Show session net win/loss + timers in the header. */
  sessionDisplays: boolean;

  useCurrencySymbol: boolean;
}

/** Current production SkyX behavior (unchanged when jurisdiction is standard). */
export const STANDARD_POLICY: RegulatoryPolicy = {
  jurisdiction: 'standard',
  autoplay: true,
  dualBet: true,
  chat: true,
  /** skyx_new already disables keyboard betting for all markets. */
  keyboardBetting: false,
  autoCashout: true,
  centerAutoCashout: false,
  winCelebration: 'all',
  rulesSections: [
    'bet_cash_out',
    'auto_play',
    'live_bets',
    'randomization',
    'game_menu',
    'other',
  ],
  rulesThirdPartyUiDisclaimer: false,
  sessionDisplays: false,
  useCurrencySymbol: true,
};
